import { FeatureGroup } from '../../products/models/product.model';
import { useShowSiteServicePeriods } from '../../services/api/useShowSiteServicePeriods';
import { Site } from '../../sites/models/site.model';

/**
 * Returns whether or not the account is eligible for a trial v2, based on its site plans and
 * the account's migration to service management.
 *
 * As of writing this, the rules are that the account's all sites are eligible for a trial v2,
 * as long as there's at least one site on a paid plan, and the account is migrated to service
 * management.
 *
 * @param sites Array of `Site` objects
 * @returns The account's trial v2 eligibility
 */
export const useAccountTrialV2Eligibility = (sites: Array<Site>): boolean => {
  const firstPaidSite = sites.find((site) =>
    site.products.some(
      (product) => product.effective_feature_group !== FeatureGroup.Basic
    )
  );
  const { siteServicePeriodsData: servicePeriods } = useShowSiteServicePeriods(
    firstPaidSite?.site_id.toString()
  );

  return !!firstPaidSite && !!servicePeriods;
};
